import request from '@/utils/request'

//分页
export function feedbackPage(data) {
  return request({
    url: '/mg/notice-api/feedback/page',
    method: 'post',
    data,
  })
}
//新增反馈
export function feedbackSave(data) {
  return request({
    url: '/mg/notice-api/feedback',
    method: 'put',
    data,
  })
}
//查询单条
export function getFeedbackById(id) {
  return request({
    url: `/mg/notice-api/feedback/${id}`,
    method: 'get',
  })
}
//回复
export function feedbackReply(data) {
  return request({
    url: `/mg/notice-api/feedback/reply`,
    method: 'post',
    data,
  })
}
//未读数量
export function feedbackUnreadCount(params) {
  return request({
    url: `/mg/notice-api/feedback/unreadCount`,
    method: 'get',
    params,
  })
}

export function getAliyunToken(data) {
  return request({
    url: '/mg/notice-api/componentFile/requestSTSToken',
    method: 'post',
    data,
  })
}
